module.exports = __webpack_public_path__ + "media/images/pen_skyblue-03097a92.png";